import React from "react";
import HeadComponent from "../Head";

interface PageWrapperProps {
    children: React.ReactNode;
}

const PageWrapper = ({ children }: PageWrapperProps) => {
    return (
        <>
            <HeadComponent />
            {children}
        </>
    );
};

export default PageWrapper;
